/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiMatchSourceType } from './ApiMatchSourceType';
import {
    ApiMatchSourceTypeFromJSON,
    ApiMatchSourceTypeFromJSONTyped,
    ApiMatchSourceTypeToJSON,
    ApiMatchSourceTypeToJSONTyped,
} from './ApiMatchSourceType';

/**
 * 
 * @export
 * @interface ApiMatchSource
 */
export interface ApiMatchSource {
    /**
     * 
     * @type {number}
     * @memberof ApiMatchSource
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiMatchSource
     */
    fieldKey?: string;
    /**
     * 
     * @type {ApiMatchSourceType}
     * @memberof ApiMatchSource
     */
    type: ApiMatchSourceType;
}



/**
 * Check if a given object implements the ApiMatchSource interface.
 */
export function instanceOfApiMatchSource(value: object): value is ApiMatchSource {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ApiMatchSourceFromJSON(json: any): ApiMatchSource {
    return ApiMatchSourceFromJSONTyped(json, false);
}

export function ApiMatchSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiMatchSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fieldKey': json['fieldKey'] == null ? undefined : json['fieldKey'],
        'type': ApiMatchSourceTypeFromJSON(json['type']),
    };
}

export function ApiMatchSourceToJSON(json: any): ApiMatchSource {
    return ApiMatchSourceToJSONTyped(json, false);
}

export function ApiMatchSourceToJSONTyped(value?: ApiMatchSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fieldKey': value['fieldKey'],
        'type': ApiMatchSourceTypeToJSON(value['type']),
    };
}

